const size = {
  xs: "575px", // for small screen mobile
  sm: "576px", // for mobile screen
  md: "768px", // for tablets
  lg: "992px", // for laptops
  xl: "1200px", // for desktop / monitors
  xxl: "1600px", // for big screens
};

const breakpoints = {
  xs: `(max-width: ${size.xs})`,
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
};

export default breakpoints;
